// This reducer manages state for histo data.
// The data is saved per sensor and per widget, that consumes it,
// since different widgets might display different histo data for the same sensor (e.g. different time intervals)

import { actionsTypes as types } from "../actions/sensorHistoActions";

// {
//     "widgetid1": {
//         "sensorid1" : "data",
//         "sensorid2" : "data",
//          "meta"?
//     },
//     "widgetid2": {
//         "sensorid1" : "data",
//         "sensorid2" : "data"
//     }
// }

const sensorHistoReducer = (state = {}, action) => {
    switch (action.type) {
        case types.RECEIVE_SENSOR_HISTO_DATA:
            console.log("RECEIVE_SENSORHISTO reducer called!", action);

            return {
                ...state,
                [action.widgetid]: {
                    ...state[action.widgetid], 
                        [action.deviceid]: {
                            ...(state[action.widgetid] && state[action.widgetid][action.deviceid]),
                            [action.sensorid]: action.data
                        }
                }
            }
            // return state.map(device => {
            //     return device.uid === action.deviceid
            //       ? {
            //           ...device,
            //           histoSensorValues: {
            //             ...device.histoSensorValues,
            //             [action.sensorid]: action.data
            //           }
            //         }
            //       :device;
            // });

        default:
            return state
    }
}

export default sensorHistoReducer